var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col overflow-hidden"},[(_vm.showSteps)?_c('wizard-steps'):_vm._e(),_vm._v(" "),_c('wizard-content',[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in","appear":""}},[_c('router-view')],1)],1),_vm._v(" "),_c('portal-target',{attrs:{"name":"contact-question-banner"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }